<template>
  <div>
    <PageTitle
      title="Bed Types"
      :btnCreate="true"
      :createRoute="'/purchase/add'"
      :createPopup="true"
      @onClickCreate="OpenModal()"
      :permission="'Bed Type Create'"
    />
    <v-container fluid class="lighten-12 content">
      <v-card class="lighten-12 card-content mb-2">
        <v-row class="ma-0 align-right">
          <TableFilters
            :filters="['status', 'search']"
            v-model="filter"
            :columns="columns"
          ></TableFilters>
          <ImportExportMenu :permission="'Category Report'"></ImportExportMenu>
        </v-row>
      </v-card>
      <v-card class="lighten-12 card-content mt-0 pa-3">
        <v-col
          class="pr-1 text-right"
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          xl="2"
        >
          <CategoryForm
            :visible="isBedTypeFormVisible"
            @close="AddCategory($event)"
            @afterSave="refreshData()"
          />
        </v-col>

        <v-progress-linear
          active="false"
          indeterminate="false"
          :query="false"
          v-if="isLoading"
        ></v-progress-linear>
        <v-data-table
          :fixed-header="true"
          :headers="headers"
          :items-per-page="paginationOptions.perPage"
          :items="Bedtypedata"
          class="row-pointer"
          item-key="id"
          hide-default-footer
        >
          <!-- <template v-slot:no-data>
            <img style="height: 200px;" src="assets/img/no-result.jpg" />
          </template> -->
          <!-- No -->
          <template v-slot:item.no>
            <v-icon>mdi-vuetify</v-icon>
          </template>

          <!-- Status -->
          <template v-slot:item.is_active="{ item }" :slot-scope="props">
            <v-chip
              :x-small="true"
              class="ma-2"
              label
              text-color="white"
              :color="getStatusColor(item.is_active)"
              dark
              >{{ item.is_active ? "Active" : "Archived" }}</v-chip
            >
          </template>

          <!-- Action -->
          <template v-slot:item.action="{ item }">
            <list-menu
              feature="bedtypes"
              :item="item"
              editPermission="Bed Type Edit"
              softDeletePermission="Bed Type Soft Delete"
              @refreshList="refreshData"
              @onEditClicked="EditModal(item)"
              :isEditModal="true"
              :isSubViewModal="true"
              @onSubViewClicked="ViewCategory(item)"
            ></list-menu>
          </template>
          <template v-slot:footer>
            <pagination
              url="hms/bed-types"
              @paginationOptions="setPaginationOptions"
              @response="receiveBedtypeData"
              :filter="filter"
              ref="pagination"
            />
          </template>
        </v-data-table>

        <EditBedTypeForm
          :visible="EditScheduleForm"
          :bedtype="editBedTypedata"
          @afterSave="refreshData()"
          @close="EditBedType($event)"
        />
      </v-card>
    </v-container>
  </div>
</template>

<script>
import TableFilters from "@/components/base/TableFilters";
import CategoryForm from "./BedTypeCreate";
import { required, email, max } from "vee-validate/dist/rules";
import pagination from "@/modules/shared/components/pagination";

import FileUpload from "@/components/base/FileUpload";
import confirmation from "@/modules/shared/components/confirmation";
import { ProductCategory } from "../../../models/ProductCategory";
import EditBedTypeForm from "./BedTypeEdit";
import _ from "lodash";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  data: () => ({
    paginationOptions: {},
    isBedTypeFormVisible: false,
    EditScheduleForm: false,
    Bedtypedata: [],
    editBedTypedata: new bedtype(),
    pagination1: {
      descending: true,
      page: 1,
      rowsPerPage: 2,
      sortBy: "fat",
      totalItems: 0,
      rowsPerPageItems: [1, 2, 4, 8, 16],
    },
    pagination: {
      page: 1,
      itemsPerPage: 2,
    },
    page: 1,
    status: [
      { text: "Active", value: "active" },
      { text: "Archived", value: "archived" },
    ],
    columns: [
      {
        text: "Name",
        value: "name",
        show: true,
        disabled: false,
        width: "16.5%",
      },
      {
        text: "Code",
        value: "code",
        show: true,
        disabled: false,
        width: "16.5%",
      },

      {
        text: "Status",
        value: "is_active",
        show: true,
        disabled: false,
        align: "center",
        width: "16.5%",
      },
      {
        text: "Actions",
        value: "action",
        show: true,
        disabled: false,
        align: "center",
        width: "16.5%",
      },
    ],

    filter: {
      name: "",
      search: "",
      status: "",
    },
  }),
  computed: {
    headers: function() {
      return this.columns.filter((item) => item.show == true);
    },
  },

  components: {
    ValidationProvider,
    ValidationObserver,
    CategoryForm,
    pagination,
    EditBedTypeForm,
    TableFilters,
  },

  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    clearFilter() {
      this.filter = {};
    },
    navigate(item) {
      console.log(item);
    },

    OpenModal() {
      this.isBedTypeFormVisible = true;
    },

    receiveBedtypeData(data) {
      
      this.Bedtypedata = data;
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },

    AddCategory($event) {
      this.isBedTypeFormVisible = false;
    },
    EditModal(data) {
      
      this.EditScheduleForm = true;
      this.GetBedtype(data.id);
    },
    EditBedType($event) {
      this.EditScheduleForm = false;
    },
    GetBedtype(id) {
      this.$store

        .dispatch(`bedtype/GetBedType`, id)
        .then((res) => {
          
          this.editBedTypedata = new bedtype().SetData(res.data);
          
          this.refreshData();
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    getStatusColor(status) {
      return status ? "green" : "gray";
    },
  },
  created() {
    this.refreshData();
  },
};
export class bedtype {
  constructor() {
    this.id = null;
    this.name = "";
    this.code = "";
    this.is_active = false;
  }

  SetData(u) {
    
    let bedtype = new Object();
    bedtype.id = u.id ? u.id : "";
    bedtype.name = u.name ? u.name : "";
    bedtype.code = u.code ? u.code : "";

    return bedtype;
  }
}
</script>
